/**
 * Application configuration from environment variables
 */

interface AppConfig {
  apiBaseUrl: string;
  googleAnalyticsId?: string;
  gtmId?: string;
  facebookPixelId?: string;
  contactEmail: string;
  phoneNumber: string;
  whatsappNumber: string;
}

const config: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_URL || '/api',
  googleAnalyticsId: import.meta.env.VITE_GA_MEASUREMENT_ID,
  gtmId: import.meta.env.VITE_GTM_ID,
  facebookPixelId: import.meta.env.VITE_FACEBOOK_PIXEL_ID,
  contactEmail: 'geral@magreen.pt',
  phoneNumber: '+351913225858',
  whatsappNumber: '351913225858'
};

export default config;
